import { useDeviceSelect } from '@modules/reception/device-select'

export const useTablet = () => useDeviceSelect('tablet_id')
